class SiteCardPositionerDesktop
    implements ISiteCardPositioner {
    
    private _currentSize?: DOMRect;
    private _totalSize: number = 0;
    private _totalLargeCards: number = 0;
    private _cards: ISiteCard[] = [];

    constructor(container: SiteContainer, cards: ISiteCard[]) {
        this._cards = cards || [];
        this._calculateCards();
    }

    addCard(card: ISiteCard) {
        this._cards.push(card);
        this._totalSize += this._getWidth(card);
        this._totalLargeCards += card.isLarge() ? 1 : 0;
        this._redraw();
    }
    replaceCard(oldCard: ISiteCard, newCard: ISiteCard): void {
        this._cards[this._cards.indexOf(oldCard)] = newCard;
        this._redraw();
    }
    removeCard(card: ISiteCard) {
        let position = this._cards.indexOf(card);

        // Already removed?
        if (position === -1)
            return;
        
        this._totalSize -= this._getWidth(card);
        this._totalLargeCards -= card.isLarge() ? 1 : 0;

        // Remove from array
        this._cards.splice(position, 1);
        this._redraw();
    }
    resize(position: DOMRect) {
        this._currentSize = position;
        this._redraw();
    }
    destruct() {
        // Unset all lefts
        for(let card of this._cards) {
            let style = card.style();
            if (style !== undefined) {
                style.removeProperty("left");
                style.removeProperty("width");
            }
        }
    }
    redraw() {
        this._calculateCards();
        this._redraw();
    }
    private _calculateCards() {
        this._totalSize = 0;
        this._totalLargeCards = 0;
        for(let card of this._cards) {
            this._totalSize += this._getWidth(card);
            this._totalLargeCards += card.isLarge() ? 1 : 0;
        }
    }
    private _getWidth(card: ISiteCard) {
        let width = parseInt(card.getAttr("data-width") || "0");
        if (!width) {
            let position = card.position();
            width = (position && position.width) || 0;
            card.setAttr("data-width", width + "");
        }
        return width;
    }
    private _redraw() {
        if(this._cards.length == 0 || !this._currentSize)
            return;
        
        let currentWidth = this._currentSize.width;

        let firstCard = this._cards[0];
        let firstCardStyle = firstCard.style();
        let firstCardPosition = firstCard.position();
        
        // Set first card to first position
        if(firstCardStyle !== undefined)
            firstCardStyle.left = '0px';
        
        let staticSize = (firstCardPosition && firstCardPosition.width) || 0;
        let totalSize = this._totalSize - staticSize;

        let currentPosition = staticSize;
        let largeCardAsSmall = 0;

        // Do we have a static card?
        var startIndex = 1;
        if(this._cards.some(a => a.isLarge())) {
            for(var card of this._cards.slice(1)) {
                let style = card.style();
                if (style === undefined)
                    continue;

                if (card.isLarge())
                    break;

                startIndex++;

                style.left = `${currentPosition}px`;
                style.removeProperty("width");

                let width = this._getWidth(card);
                currentPosition += 25;
                totalSize -= width - 25;

                card.trigger("qts.resize", false);
            }
        }
        
        for(let card of this._cards.slice(startIndex)) {
            let style = card.style();
            if (style === undefined)
                continue;

            style.left = `${currentPosition}px`;
            style.removeProperty("width");

            let width = this._getWidth(card);
            if (staticSize + totalSize > currentWidth) {
                // Display small
                currentPosition += 25;
                totalSize -= width - 25;
                if (card.isLarge())
                    largeCardAsSmall += 1;
            } else {
                // Display full
                if (card.isLarge()) {
                    width = width + ((currentWidth - (staticSize + totalSize)) / (this._totalLargeCards - largeCardAsSmall));
                    style.width = width + "px";
                }
                currentPosition += width;
            }
            card.trigger("qts.resize", false);
            
        }
    }
}